<div style="height:1200px;">
  <quorum-slim-editor (onTemplateChanged)="localCall($event)"></quorum-slim-editor>
</div>